import { render, staticRenderFns } from "./CrewDetail.vue?vue&type=template&id=e61fd4f6&scoped=true"
import script from "./CrewDetail.vue?vue&type=script&lang=js"
export * from "./CrewDetail.vue?vue&type=script&lang=js"
import style0 from "./CrewDetail.vue?vue&type=style&index=0&id=e61fd4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61fd4f6",
  null
  
)

export default component.exports